import { FC, PropsWithChildren, useMemo, useState } from "react";
import { LayoutModeContext } from "../../../contexts/data/LayoutContext";
import { LayoutMode } from "../../../enums/LayoutMode";

/**
 * --- Interfaces ---
 */
export interface ILayoutModeProviderProps extends PropsWithChildren {}

/**
 * --- Layout Provider ---
 */
export const LayoutModeProvider: FC<ILayoutModeProviderProps> = ({
    children
}) => {
    const [mode, setMode] = useState(LayoutMode.Default);

    const context = useMemo(() => {
        return {
            mode,
            setMode
        }
    }, [mode, setMode]);

    return (
        <LayoutModeContext.Provider value={context}>
            {children}
        </LayoutModeContext.Provider>
    )
}